import React from "react";

import * as Icons from "lucide-react";

import { Card, CardContent } from "~/components/ui/card";
import { KPIDashboardProps } from "~/pages/purchase-orders/types/sales-notes";
import { formatCurrency } from "~/utils/helpers";

export const KPIDashboard: React.FC<KPIDashboardProps> = ({
  totalOrders,
  totalAmount,
  pendingAmount,
  approvalRate,
  displayedOrders,
}) => {
  return (
    <div className="grid w-full max-w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
      <Card className="w-full max-w-full border-none bg-blue-50 shadow-sm">
        <CardContent className="w-full max-w-full pb-3 pt-4">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">
                Total Notas
              </p>
              <p className="text-2xl font-bold">{totalOrders}</p>
            </div>
            <div className="rounded-full bg-blue-100 p-2">
              <Icons.Calendar className="h-4 w-4 text-blue-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="w-full max-w-full border-none bg-green-50 shadow-sm">
        <CardContent className="w-full max-w-full pb-3 pt-4">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">
                Monto Total
              </p>
              <p className="text-2xl font-bold">
                {formatCurrency(totalAmount)}
              </p>
            </div>
            <div className="rounded-full bg-green-100 p-2">
              <Icons.TrendingUp className="h-4 w-4 text-green-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="w-full max-w-full border-none bg-amber-50 shadow-sm">
        <CardContent className="w-full max-w-full pb-3 pt-4">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">
                Pendiente de Pago
              </p>
              <p className="text-2xl font-bold">
                {formatCurrency(pendingAmount)}
              </p>
            </div>
            <div className="rounded-full bg-amber-100 p-2">
              <Icons.Calendar className="h-4 w-4 text-amber-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="w-full max-w-full border-none bg-purple-50 shadow-sm">
        <CardContent className="w-full max-w-full pb-3 pt-4">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-xs font-medium text-muted-foreground">
                Tasa de Aprobación
              </p>
              <p className="text-2xl font-bold">{approvalRate}%</p>
              <p className="text-xs text-muted-foreground">
                {displayedOrders.filter((o) => o.status === "accepted").length}{" "}
                aprobadas
              </p>
            </div>
            <div className="rounded-full bg-purple-100 p-2">
              <Icons.PieChart className="h-4 w-4 text-purple-600" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default KPIDashboard;
